const defaultLayerOption = { enableAltitude: true }

export const LAYER_OPTIONS = {
  venue: { ...defaultLayerOption },
  level: { ...defaultLayerOption },
  fixture: { ...defaultLayerOption, enableSimplify: false },
  unit: { ...defaultLayerOption, enableSimplify: false },
  kiosk: { ...defaultLayerOption, enableSimplify: false },
  opening: { ...defaultLayerOption },
  section: { ...defaultLayerOption, visible: false },
  anchor: { ...defaultLayerOption },
  amenity: { ...defaultLayerOption },
  "route.path": { ...defaultLayerOption, visible: false },
  hilight: { ...defaultLayerOption },
  "route.marker": { ...defaultLayerOption, visible: false, zIndex: 99 },
  occupant: { ...defaultLayerOption, zIndex: 10 },
  user_location: { ...defaultLayerOption, zIndex: 99 },
}
